import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * PageLoader — Full-page loading spinner used as the Suspense fallback
 * for all lazy-loaded route components.
 */
const PageLoader = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: 2,
      }}
    >
      <CircularProgress size={40} thickness={4} color="primary" />
      <Typography variant="body2" color="text.secondary">
        Cargando...
      </Typography>
    </Box>
  );
};

export default PageLoader;
